import React, { Component } from "react";
import { get } from "../../../../../utils/request";
import "./style.css";
import "../../../../../index.css";
class ToCollegeToolConditionScore extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tip: "",
    };
  }

  componentDidMount = () => {
    this.requestToolConfig();
  };
  render() {
    const {
      handleNext,
      wholeSubject,
      subjectCondition,
      handleAddScore,
      subjectScore,
      totalScore,
    } = this.props;
    return (
      <div className="toCollegeToolConditionScore_box">
        <div className="toCollegeToolConditionScore_img_box">
          <img
            alt=""
            src={require("../../../../../images/tocollege/input_subject.png")}
          ></img>
        </div>
        <div className="toCollegeToolConditionScore_score_box">
          <div className="height_42">
            <div className="fl toCollegeToolConditionScore_score_div">
              <div className="fl pt_10 pr_5">语文</div>
              <input
                onChange={(e) => handleAddScore(e, "语文")}
                className="fl"
                value={subjectScore["语文"]}
              ></input>
            </div>
            <div className="fl toCollegeToolConditionScore_score_div">
              <div className="fl pt_10 pr_5">数学</div>
              <input
                onChange={(e) => handleAddScore(e, "数学")}
                className="fl"
                value={subjectScore["数学"]}
              ></input>
            </div>
            <div className="fl toCollegeToolConditionScore_score_div">
              <div className="fl pt_10 pr_5">外语</div>
              <input
                onChange={(e) => handleAddScore(e, "外语")}
                className="fl"
                value={subjectScore["外语"]}
              ></input>
            </div>
          </div>
          <div
            className={
              subjectCondition.length > 0
                ? "height_42 major_top_10 "
                : "height_42 major_top_10 display_none"
            }
          >
            <div
              className={
                subjectCondition[0] !== undefined
                  ? "fl toCollegeToolConditionScore_score_div "
                  : "fl toCollegeToolConditionScore_score_div display_none"
              }
            >
              <div className="fl pt_10 pr_5">
                {wholeSubject[subjectCondition[0]]}
              </div>
              <input
                onChange={(e) =>
                  handleAddScore(e, wholeSubject[subjectCondition[0]])
                }
                className="fl"
                value={subjectScore[wholeSubject[subjectCondition[0]]] || ""}
              ></input>
            </div>
            <div
              className={
                subjectCondition[1] !== undefined
                  ? "fl toCollegeToolConditionScore_score_div "
                  : "fl toCollegeToolConditionScore_score_div display_none"
              }
            >
              <div className="fl pt_10 pr_5">
                {wholeSubject[subjectCondition[1]]}
              </div>
              <input
                onChange={(e) =>
                  handleAddScore(e, wholeSubject[subjectCondition[1]])
                }
                className="fl"
                value={subjectScore[wholeSubject[subjectCondition[1]]] || ""}
              ></input>
            </div>
            <div
              className={
                subjectCondition[2] !== undefined
                  ? "fl toCollegeToolConditionScore_score_div "
                  : "fl toCollegeToolConditionScore_score_div display_none"
              }
            >
              <div className="fl pt_10 pr_5">
                {wholeSubject[subjectCondition[2]]}
              </div>
              <input
                onChange={(e) =>
                  handleAddScore(e, wholeSubject[subjectCondition[2]])
                }
                className="fl"
                value={subjectScore[wholeSubject[subjectCondition[2]]] || ""}
              ></input>
            </div>
          </div>
          <div
            className=" height_42
           toCollegeToolConditionScore_total_score_div
           major_top_20"
          >
            <div className="fl pt_10 pr_5">总分</div>
            <input
              onChange={(e) => handleAddScore(e, "总分")}
              value={totalScore}
              className="fl"
            ></input>
          </div>
        </div>
        <div
          onClick={() => handleNext()}
          className="toCollegeToolConditionScoreNext_btn_box"
        >
          下一步
        </div>
        <div className="major_top_15 color_fe5900 major_left_20 major_right_20 line_height_25" style={{textAlign:"justify"}}>
        {this.state.tip}
        </div>
      </div>
    );
  }
    /**
   * 获取工具的配置信息
   */
    requestToolConfig = () => {
      get("/public/v1/tool").then((res) => {
        res.data.forEach((element) => {
          if (element.name === "no_senior") {
            if(element.value==="close") {
              this.setState({
                tip: "特别提醒：此功能现仅面向高三学子开放，非高三学子请不要使用此功能，如果使用，高考季后将会过期处理。",
              });
            }else{
              this.setState({
                tip: "特别提醒：高考后，此功能仅面向高三学子开放，非高三学子后面会重新开放。",
              });
            }
          }
        });
      });
    };
}

export default ToCollegeToolConditionScore;



// WEBPACK FOOTER //
// ./src/containers/ToCollegeTool/ToCollegeToolCondition/components/ToCollegeToolConditionScore/index.js